
export const featurePaths = {
    userList: "/userlist",
    createUser: "/userlist/createuser",

} as const;

export const apiPaths = {} as const;
